module.exports = __webpack_public_path__ + "static/3b-8253a5eeefe8610e7a4d9636ff09a3b2.jpg";